import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Container } from "olive-react-myoneui";
import Row from "olive-react-myoneui/lib/Row";
import Col from "olive-react-myoneui/lib/Col";
import { useSelector } from 'react-redux';
import Dashboard from "../../../components/afterLogin/student-dashboard/Dashboard";
import { getLangFromCache } from "../../../utils/helpers";
import PuffLoader from "react-spinners/PuffLoader";
import { readCookie } from "../../../utils/cookie";
import CompleteProfile from "./CompleteProfile";
import { getProfileFieldBlocks, updateProfileFields } from "../../../api/afterLogin/learners";
import { getSPAuthTokens } from "../../../helpers/spauth_token_helper";

const StudentDashboard = () => {
  const [spuid, setSpuid] = useState("");
  const [error, setError] = useState("loading");
  const [showLoader, setShowLoader] = useState(false);
  const [hideApprenticeship, setHideApprenticeship] = useState("");
  const configData = useSelector((state) => state.config);
  const adminData  = useSelector((state) => state.admin);
  const learnerId  = configData?.session?.id ?? 0;
  const [profileFieldBlocks, setProfileFieldBlocks] = useState({});

  const secret        = adminData.secret;
  const roleid        = adminData.us_role_id;
  const signature     = adminData.signature;
  const planFeatures  = adminData.features;
  const userid        = adminData.user_id;
  const products      = adminData.products;
  const name          = adminData.us_name;
  const accountid     = adminData.account_id;
  const timezone      = adminData.us_timezone;
  const uuid          = adminData.us_uid;
  const [searchParams]= useSearchParams();
  const fill          = searchParams.get("fill") ?? null;
  const profileSkipped= localStorage.getItem("profileSkipped");
  const [showComplete, setShowComplete] = useState(
    (fill !== null && fill === "1") ? 0 :
    profileSkipped === "true" ? 1 :
    configData?.session?.us_profile_completed ?? 0
  );
  const learnerProfileFields = configData?.session?.us_profile_fields;
  const profileFields = learnerProfileFields && learnerProfileFields !== null ? learnerProfileFields.split("{#}") : false;

  let langFromCache = getLangFromCache();
  if (langFromCache === null) {
    langFromCache = "en";
  }
  let preview_as_user = readCookie("preview_as_user");

  // AUTH TOKENS
  const [authSPTokens, setAuthSPTokens] = useState(false);
  
  useEffect(() => {
    if (learnerId) {
      const fetchTokenData = async () => {
        const [mykademy, newsfeed, eportfolio] = await Promise.all([
          getSPAuthTokens('mykademy',configData.access_token),
          getSPAuthTokens('newsfeed',configData.access_token),
          getSPAuthTokens('eportfolio',configData.access_token)
        ]);
        const tokenData = {
          mykademy,
          newsfeed,
          eportfolio
        };
        if (tokenData) {
          setAuthSPTokens(tokenData);
        }
      };
      fetchTokenData();
    }
    if (roleid) {
      if (roleid != 2 && preview_as_user !== "preview_as_user") {
        setError("loading")
        window.location.href = '/admin';
      }
      else {
        const found = products && products.some(function (el) {
          return el.sp_uid == 'mykademy' || el.sp_uid === 'dms' || el.sp_uid === 'tms' || el.sp_uid === 'eportfolio' || el.sp_uid === 'myconnect';
        });
        setError(found)
      }
    }

    const found = products && products.some(function (el) {
      return el.sp_slug === "eportfolio";
    });

    if (found) {
      setHideApprenticeship(false)
    } else {
      setHideApprenticeship(true)
    }
  }, [roleid, products])

  const loadProfileFieldBlocks = async () => {
    const profileProfileblocks = await getProfileFieldBlocks(
      configData.access_token
    );
    if (profileProfileblocks) {
      setProfileFieldBlocks(profileProfileblocks);
    }
  };
  useEffect(() => {
    loadProfileFieldBlocks();
  }, []);
  const userProfileFieldData = {};
  if (profileFields) {
      profileFields.forEach((field) => {
        field = field.substring(2, field.length - 2);
        if (field != "{=>}") {
          const tempField = field.split("{=>}");
          const key = tempField[0] || 0;
          const value = tempField[1] || "";
          userProfileFieldData[key] = value;
        }
      });
  }
  const hasMissingDataForMandatoryFields = Object.values(profileFieldBlocks || {}).some(block => 
    block.profile_fields?.some(field => {
      if (field.pf_mandatory === "1") {
        const fieldKey = field.id;
        return !userProfileFieldData[fieldKey] || userProfileFieldData[fieldKey] === "";
      }
      return false;
    })
  );
  useEffect(() => {
    const addressMandatory = configData?.address_mandatory === "1";
    const phnoMandatory = configData?.phno_mandatory === "1";
    const userAddress = configData?.session?.us_address;
    const isAddressMissing = !userAddress || Object.keys(userAddress).length === 0;
    const userPhone = configData?.session?.us_phone;
    const userCountryCode = configData?.session?.us_country_code;
    const isPhoneMissing = !userPhone || userPhone.trim() === "" || !userCountryCode || userCountryCode.trim() === "";
    const hasProfileFieldIssue =
      Object.keys(profileFieldBlocks || {}).length > 0 && hasMissingDataForMandatoryFields;

       if (
      profileSkipped === "true" &&
      !addressMandatory &&
      !phnoMandatory
    ) {
      setShowComplete(1);
      return;
    }

    if (hasProfileFieldIssue || isAddressMissing || isPhoneMissing) {
      setShowComplete(0);
    } else {
      setShowComplete(1);
    }
  }, [profileFieldBlocks, learnerProfileFields, configData, profileSkipped]);

  return (
    <>
      {showComplete == 0 ? (
        <CompleteProfile setShowComplete={setShowComplete} profileFieldBlocks={profileFieldBlocks} hasMissingDataForMandatoryFields={hasMissingDataForMandatoryFields}/>
      ) : (
      <div className="dashboard-wrapper myk__stu-dash_outer-wrapper myk__stu-landing w-100">
        <Container fluid>
        {uuid && secret && langFromCache && configData && authSPTokens ? (<Dashboard hideApprenticeship={hideApprenticeship} spAuthTokens={authSPTokens} />) : 
          (<Row>
            <Col>
              <div className="p-0 text-center empty-block-wrapper d-flex align-items-center justify-content-center" style={{ height: '100vh' }}>
                <div className="empty-block">
                  <PuffLoader color="#36d7b7" />
                </div>
              </div>
            </Col>
          </Row>
          )}
        </Container>
      </div>
      )}
    </>
  );
}

export default StudentDashboard;
